var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v(" Editar Solicitud")]),
                  _c("v-spacer"),
                  _c("v-toolbar-items")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-tabs",
                          [
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "general"
                                  }
                                }
                              },
                              [_vm._v("General")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "simCards"
                                  }
                                }
                              },
                              [_vm._v("SIM cards")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step == "general",
                                expression: "step == 'general'"
                              }
                            ],
                            staticClass: "rounded-card"
                          },
                          [
                            _c("General", {
                              attrs: {
                                editedItem: _vm.editedItem,
                                motivos: _vm.motivos
                              },
                              on: {
                                editado: function($event) {
                                  return _vm.confirmCallbackConfirm($event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step == "simCards",
                                expression: "step == 'simCards'"
                              }
                            ],
                            staticClass: "rounded-card"
                          },
                          [
                            _c("Sims", {
                              attrs: { editedItem: _vm.editedItem }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }